import { cycleCountRuleIdFormat } from "@redotech/redo-ids-cockroach";
import { cycleCountRuleDataSchema } from "@redotech/redo-inventory-common/cycle-counts";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const upsertCycleCountRule = unaryRpc({
  name: "upsertCycleCountRule" as const,
  input: z.object({
    id: cycleCountRuleIdFormat.schema.nullable(),
    name: z.string().min(1).max(200),
    description: z.string().nullable(),
    status: z.enum(["live", "disabled", "draft"]),
    dueDaysAfterCreation: z.int().min(1).max(365),
    assignedRole: z.string().nullable().optional(),
    assignedUserId: z.string().nullable().optional(),
    typed: cycleCountRuleDataSchema,
  }),
  output: z.object({ id: cycleCountRuleIdFormat.schema }),
});
